import { t } from '../services/language-manager';

interface BackButtonProps {
  onClick: () => void;
}

/** Compact top-nav Back with a leading chevron. Used on Settings and Actions. */
export function BackButton({ onClick }: BackButtonProps) {
  return (
    <button type="button" className="btn btn--secondary btn--small settings-page__back" onClick={onClick}>
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M15 18l-6-6 6-6" />
      </svg>
      {t('settings-back')}
    </button>
  );
}
